import 'jquery.mmenu/dist/jquery.mmenu'
import 'jquery.mmenu/dist/addons/navbars/jquery.mmenu.navbars'

$(document).ready(function() {
    $("#mobileMenu").mmenu({
        extensions: ["position-right", "navbars"],
        'navbars': [{
            'position': 'top',
            'content': '#language-menu-mobile'
        }]
    }, {
        // configuration
        offCanvas: {
            pageSelector: "#page"
        },
        classNames: {
            selected: "active"
        }
    });
});
